import { render, staticRenderFns } from "./SendCNPJSPanel.vue?vue&type=template&id=36812826&"
import script from "./SendCNPJSPanel.vue?vue&type=script&lang=ts&"
export * from "./SendCNPJSPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SendCNPJSPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports